import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@musa.tech/design-system';
import { OnDemandPeriod } from '@/integrations/agreements/client';
import { PERIOD_LABELS } from '@/utils/onDemandRequestRules';

const NO_PERIOD = 'none';

/** Turno pedido para a visita: diurno, noturno ou sem preferência (nulo). */
export const PeriodSelect: React.FC<{
  value: OnDemandPeriod | null;
  onChange: (value: OnDemandPeriod | null) => void;
  ariaLabel: string;
}> = ({ value, onChange, ariaLabel }) => (
  <Select
    value={value != null ? String(value) : NO_PERIOD}
    onValueChange={(next) => onChange(next === NO_PERIOD ? null : (Number(next) as OnDemandPeriod))}
  >
    <SelectTrigger aria-label={ariaLabel}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value={NO_PERIOD}>Sem preferência</SelectItem>
      <SelectItem value={String(OnDemandPeriod.DIURNO)}>{PERIOD_LABELS[OnDemandPeriod.DIURNO]}</SelectItem>
      <SelectItem value={String(OnDemandPeriod.NOTURNO)}>{PERIOD_LABELS[OnDemandPeriod.NOTURNO]}</SelectItem>
    </SelectContent>
  </Select>
);
